import { useContext, useMemo, useState } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import InputConfig from '../../../../Components/InputConfig';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
import DropDownSingle from '../../../../Components/DropDownSingle';
import { PENCIL_FLOAT_POSITIONS } from '../../../../core/constants';

//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Divider, Grid, Paper, Typography } from '@mui/material';
//===============

const PencilFloatConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext

	const [pencilFloatPosition, setPencilFloatPosition] = useState(
		rawConfig[keyData + '.position'] || ''
	);

	const handlePositionChange = (value) => {
		setPencilFloatPosition(value);
		updateRawConfig({ ...rawConfig, [keyData + '.position']: value });
	};

	useMemo(() => {
		setPencilFloatPosition(rawConfig[keyData + '.position'] || '');
	}, [rawConfig]);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Pencil Float"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Pencil Float']}
				description="Manage Pencil Float Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={2} style={{ marginTop: '1rem', marginLeft: '4rem', width: '90%' }}>
				<Grid item xs={4} style={{ marginTop: '2rem' }}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>

				<Divider style={{ width: '100%', margin: '2rem 0 3rem' }} />

				<Grid item xs={12} style={{ display: 'flex', flexWrap: 'wrap', gap: '3rem' }}>
					<Grid item xs={4}>
						<InputConfig
							editable={!!rawConfig[keyData + '.enabled']}
							label="Description Block Id"
							keyData={keyData + '.descriptonBlockId'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>

					<Grid item xs={3} style={{ minHeight: '13rem' }}>
						<DropDownSingle
							disabled={!rawConfig[keyData + '.enabled']}
							isObjectEditor={false}
							label="Position"
							list={PENCIL_FLOAT_POSITIONS}
							directValue={pencilFloatPosition}
							updateDirectValue={handlePositionChange}
							formControlStyles={{ width: '100%' }}
							formControlVariant="outlined"
							containerStyles={{ width: '100%' }}
						/>

						{pencilFloatPosition === 'center' && (
							<Typography color="error" variant="body2" style={{ height: '1.5rem' }}>
								⚠️ Warning: The description will not be displayed when the 'Center' position is
								selected.
							</Typography>
						)}
					</Grid>

					<Grid item xs={3}>
						<InputConfig
							placeholder="#1f1f1f"
							editable={!!rawConfig[keyData + '.enabled']}
							label="Background Color"
							keyData={keyData + '.backgroundColor'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>

					<Grid item xs={4}>
						<InputConfig
							editable={!!rawConfig[keyData + '.enabled']}
							multiline={true}
							rows={2}
							keyData={keyData + '.description'}
							object={rawConfig}
							label="Video Description"
							updateObject={updateRawConfig}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default PencilFloatConfig;
